import 'whatwg-fetch';

export default class CurrencySwitcher {
	static format(value, currency, round = false) {
		const currency_formatter = new Intl.NumberFormat(
			window.locale,
			{
				style: 'currency',
				currency: currency,
				minimumFractionDigits: 0
			}
		);

		const final_value = round ? Math.round(value) : value;

		return currency_formatter
			.format(+(Math.round(final_value + 'e+2') + 'e-2')) // found here https://stackoverflow.com/a/18358056
			.replace(/RUB/, '₽') // HACK: https://github.com/tc39/ecma402/issues/4
			.replace(/\s/g, '&nbsp;');
	}

	constructor(form) {
		if (!form) return;
		this.form = form;
		this.button = form.querySelector('button');

		this.button.addEventListener('change', () => {
			this._submit_currency();

			this._for_each_binded_currency_switcher(element => {
				element.cccombo.select(this._current_currency.dataset.value);
			});
		});

		this._for_each_binded_currency_switcher(element => {
			element.cccombo.select(this._current_currency.dataset.value);

			element.cccombo.button.addEventListener('change', () => {
				this.form.cccombo.select(element.cccombo.button.value);
			});
		});

		this.list = form.querySelector('ul');

		document.querySelectorAll('.convertable_price').forEach(element => {
			element.original = element.querySelector('.original');

			if (element.original) {
				element.original.innerHTML = this.constructor.format(
					element.dataset.value, element.dataset.currency
				);
			}
		});

		this.update_currency();
	}

	get currency_code() {
		return this._current_currency.dataset.code;
	}

	update_currency() {
		document
			.querySelectorAll('.entry_field__currency_symbol')
			.forEach(element => {
				element.textContent =
					this._current_currency.querySelector('.symbol').textContent;
				element
					.closest('.entry_field')
					.querySelector(
						'input[name="transportation_request[currency_from_shipper][id]"]'
					).value = this._current_currency.dataset.value;
			});

		document.querySelectorAll('.convertable_price').forEach(element => {
			const
				currency = element.dataset.currency,
				converteds = element.querySelectorAll('.converted'),
				currency_rate =
					JSON.parse(this._current_currency.dataset.rates)[currency];

			converteds.forEach(converted => {
				(converted.querySelector('span') || converted).innerHTML =
					this.constructor
						.format(
							element.dataset.value * currency_rate,
							this.currency_code,
							true
						);

				if (element.original) {
					converted.style.display =
						(currency == this.currency_code ? 'none' : '');
				}
			});
		});
	}

	get _current_currency() {
		return this.form.cccombo.selectedItem().element;
	}

	_for_each_binded_currency_switcher(callback) {
		document.querySelectorAll('.binded_currency_switcher').forEach(callback);
	}

	_submit_currency() {
		fetch(this.form.action, {
			credentials: 'same-origin',
			method: 'PUT',
			body: new FormData(this.form)
		});

		this.update_currency();
	}
}
